/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Video player with custom play button functionality
  function initVideoPlayers() {
    // Find all video containers
    const videoElements = document.querySelectorAll('.video');

    if (videoElements.length === 0) return;

    videoElements.forEach((container) => {
      const videoElement = container.querySelector('video');
      const playButton = container.querySelector('.video__play');

      if (!videoElement || !playButton) return;

      // Function to play video and hide button
      function playVideo() {
        videoElement
          .play()
          .then(() => {
            videoElement.parentElement.classList.add('is-playing');
          })
          .catch((error) => {
            console.error('Error playing video:', error);
          });
      }

      // Function to pause video and show button
      function pauseVideo() {
        videoElement.pause();
        videoElement.parentElement.classList.remove('is-playing');
      }

      // Play button click event
      playButton.addEventListener('click', (e) => {
        e.stopPropagation();
        playVideo();
      });

      // Video click event for toggling play/pause
      videoElement.addEventListener('click', () => {
        if (videoElement.paused) {
          playVideo();
        } else {
          pauseVideo();
        }
      });

      // When video ends, show the play button again
      videoElement.addEventListener('ended', () => {
        pauseVideo();
        videoElement.currentTime = 0;
      });
    });
  }

  // Initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoPlayers);
  } else {
    initVideoPlayers();
  }

  // Re-initialize when Shopify section is reloaded
  document.addEventListener('shopify:section:load', initVideoPlayers);

  // BMI CALCULATOR
  const bmiCalculatorForm = document.querySelector('[data-bmi-calculator]');
  const bmiScoreValue = document.querySelector('[data-bmi-score-value]');
  const bmiScoreDiapason = document.querySelector('[data-bmi-score-diapason]');
  const bmiRecommendation = document.querySelector('[data-bmi-recommendation]');
  const bmiSection = bmiCalculatorForm?.closest('.section-bmi');

  if (bmiCalculatorForm) {
    // Set default gender value
    const maleRadio = document.getElementById('male');
    if (maleRadio) {
      maleRadio.checked = true;
    }

    bmiCalculatorForm.addEventListener('submit', function (event) {
      event.preventDefault();

      if (bmiSection) {
        bmiSection.classList.remove('overweight', 'normal', 'underweight', 'obese');
      }

      // Get form values using FormData
      const formData = new FormData(this);
      const gender = formData.get('gender');
      const age = parseInt(formData.get('age'));
      const height = parseFloat(formData.get('height')); // in cm
      const weight = parseFloat(formData.get('weight')); // in kg

      // Calculate BMI
      const heightInMeters = height / 100;
      const bmi = weight / (heightInMeters * heightInMeters);
      const roundedBmi = Math.round(bmi * 10) / 10;

      // Display BMI value
      if (bmiScoreValue) {
        bmiScoreValue.textContent = roundedBmi;
      }

      // Determine BMI category
      let category = '';
      let recommendation = '';
      let bmiClass = '';

      if (bmi < 18.5) {
        category = window.theme?.strings?.bmi_underweight || 'Underweight';
        recommendation =
          window.theme?.strings?.bmi_recommendation_underweight ||
          "Consider consulting a healthcare provider to ensure you're getting adequate nutrition.";
        bmiClass = 'underweight';
      } else if (bmi >= 18.5 && bmi < 25) {
        category = window.theme?.strings?.bmi_normal || 'Normal weight';
        recommendation =
          window.theme?.strings?.bmi_recommendation_normal ||
          'Maintain your healthy lifestyle with balanced nutrition and regular exercise.';
        bmiClass = 'normal';
      } else if (bmi >= 25 && bmi < 30) {
        category = window.theme?.strings?.bmi_overweight || 'Overweight';
        recommendation =
          window.theme?.strings?.bmi_recommendation_overweight ||
          'Consider small changes to your diet and increasing physical activity.';
        bmiClass = 'overweight';
      } else {
        category = window.theme?.strings?.bmi_obese || 'Obese';
        recommendation =
          window.theme?.strings?.bmi_recommendation_obese ||
          'Consider consulting a healthcare provider to discuss a healthy weight management plan.';
        bmiClass = 'obese';
      }

      // Display category and recommendation
      if (bmiSection) {
        bmiSection.classList.add(bmiClass);
      }

      if (bmiScoreDiapason) {
        bmiScoreDiapason.textContent = category;
      }

      if (bmiRecommendation) {
        bmiRecommendation.textContent = recommendation;
      }

      // Show the results section
      const resultsSection = document.querySelector('.bmi-results');
      if (resultsSection) {
        resultsSection.classList.add('is-visible');
      }
    });

    // Input validation for numbers only
    const numericInputs = bmiCalculatorForm.querySelectorAll('input[type="text"]');
    numericInputs.forEach((input) => {
      input.addEventListener('input', function (e) {
        // Replace any non-numeric characters (except decimal point for height/weight)
        if (input.id === 'age') {
          this.value = this.value.replace(/[^\d]/g, '');
        } else {
          this.value = this.value.replace(/[^\d.]/g, '');
          // Ensure only one decimal point
          const parts = this.value.split('.');
          if (parts.length > 2) {
            this.value = parts[0] + '.' + parts.slice(1).join('');
          }
        }
      });
    });
  }

  // BMR Calculator

  const bmrCalculatorForm = document.querySelector('[data-bmr-calculator]');
  const bmrScoreValue = document.querySelector('[data-bmr-score-value]');
  const bmrEnergyRequired = document.querySelector('[data-bmr-energy-required]');
  const bmrRecommendation = document.querySelector('[data-bmr-recommendation]');
  const bmrSection = bmrCalculatorForm?.closest('.section-bmr');

  if (bmrCalculatorForm) {
    bmrCalculatorForm.addEventListener('submit', function (event) {
      event.preventDefault();
      const formData = new FormData(this);
      const gender = formData.get('gender');
      const age = parseInt(formData.get('age'));
      const height = parseFloat(formData.get('height')); // in cm
      const weight = parseFloat(formData.get('weight')); // in kg
      const activityLevel = formData.get('activity');

      // Define activity multipliers in an array
      const activityMultipliers = [1.2, 1.375, 1.55, 1.725, 1.9];

      // Get the selected option's index (subtract 1 to skip the placeholder)
      const activitySelect = this.querySelector('select');
      const selectedIndex = activitySelect.selectedIndex;

      // Get the appropriate multiplier (account for placeholder option)
      const activityMultiplier = selectedIndex > 0 ? activityMultipliers[selectedIndex - 1] : 1.2;

      // Calculate BMR using Mifflin-St Jeor Equation
      let bmr =
        gender === 'male' ? 10 * weight + 6.25 * height - 5 * age + 5 : 10 * weight + 6.25 * height - 5 * age - 161;

      // Calculate total daily energy expenditure with activity factor
      const tdee = Math.round(bmr * activityMultiplier);

      // Round BMR to nearest whole number
      const roundedBmr = Math.round(bmr);

      // Display BMR and energy requirement values
      if (bmrScoreValue) {
        bmrScoreValue.textContent = roundedBmr + ' kcal';
      }

      if (bmrEnergyRequired) {
        bmrEnergyRequired.textContent = tdee + ' kcal';
      }

      // Show the results section
      const resultsSection = document.querySelector('.bmr-results');
      if (resultsSection) {
        resultsSection.classList.add('is-visible');
      }

      if (bmrRecommendation) {
        bmrRecommendation.textContent = `
        Вашият базален метаболизъм е: ${tdee} kcal за ${activityLevel} за тази възраст и височина. За да поддържате теглото си, ви трябват ${roundedBmr} калории на ден.
        `;
      }
    });
  }

  // ARTICLES

  // document.addEventListener('DOMContentLoaded', function () {
  //   const articlesContainer = document.getElementById('blog-articles');

  //   if (!articlesContainer) {
  //     console.log('No blog articles container found');
  //     return;
  //   }

  //   const loadingIndicator = document.getElementById('loading-indicator');
  //   const endOfResults = document.getElementById('end-of-results');
  //   const noArticlesMessage = document.querySelector('.collection-error');

  //   const currentHost = articlesContainer.dataset.host;
  //   const blogHandle = articlesContainer.dataset.blogHandle;
  //   let currentPage = parseInt(articlesContainer.dataset.currentPage);
  //   const totalPages = parseInt(articlesContainer.dataset.totalPages);

  //   let isLoading = false;
  //   let filteredCount = 0;

  //   function filterVisibleArticles() {
  //     const allArticles = Array.from(articlesContainer.querySelectorAll('.blog-article'));
  //     filteredCount = 0;

  //     allArticles.forEach((article) => {
  //       const articleMarket = article.dataset.market;
  //       let shouldShow = false;

  //       // If metafield is empty, show everywhere
  //       if (!articleMarket || articleMarket === '') {
  //         shouldShow = true;
  //       } else {
  //         // Split the market values by comma and check if current host is included
  //         const marketValues = articleMarket.split(',').map((market) => market.trim());
  //         shouldShow = marketValues.includes(currentHost);
  //       }

  //       if (shouldShow) {
  //         article.style.display = 'block';
  //         filteredCount++;
  //       } else {
  //         article.style.display = 'none';
  //       }
  //     });

  //     // Check if we have any visible articles
  //     if (filteredCount === 0 && currentPage === 1) {
  //       if (noArticlesMessage) {
  //         noArticlesMessage.style.display = 'block';
  //       }
  //     } else {
  //       if (noArticlesMessage) {
  //         noArticlesMessage.style.display = 'none';
  //       }
  //     }
  //   }

  //   function loadNextPage() {
  //     if (isLoading || currentPage >= totalPages) return;

  //     isLoading = true;
  //     if (loadingIndicator) loadingIndicator.style.display = 'block';

  //     const nextPage = currentPage + 1;

  //     const currentUrl = new URL(window.location);
  //     currentUrl.searchParams.set('page', nextPage);
  //     const url = currentUrl.pathname + currentUrl.search;

  //     fetch(url)
  //       .then((response) => response.text())
  //       .then((html) => {
  //         const parser = new DOMParser();
  //         const doc = parser.parseFromString(html, 'text/html');
  //         const newArticles = doc.querySelectorAll('#blog-articles .blog-article');

  //         newArticles.forEach((article) => {
  //           articlesContainer.querySelector('.blog-listing').appendChild(article.cloneNode(true));
  //         });

  //         currentPage = nextPage;

  //         // Update URL
  //         const newUrl = new URL(window.location);
  //         newUrl.searchParams.set('page', currentPage);
  //         window.history.replaceState({}, '', newUrl);

  //         // Filter the newly added articles
  //         filterVisibleArticles();

  //         if (loadingIndicator) loadingIndicator.style.display = 'none';
  //         isLoading = false;

  //         // Auto-load next page if we don't have enough visible articles (minimum threshold)
  //         const minVisibleArticles = 16; // Set your desired minimum
  //         if (filteredCount < minVisibleArticles && currentPage < totalPages) {
  //           loadNextPage();
  //         }

  //         // Check if we've reached the end
  //         if (currentPage >= totalPages) {
  //           if (endOfResults) endOfResults.style.display = 'block';
  //           if (window.blogObserver) window.blogObserver.disconnect();
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error loading next page:', error);
  //         if (loadingIndicator) loadingIndicator.style.display = 'none';
  //         isLoading = false;
  //       });
  //   }

  //   // Intersection Observer for infinite scroll
  //   window.blogObserver = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting && !isLoading && currentPage < totalPages) {
  //           // Only load next page if we have visible articles on current page
  //           if (filteredCount > 0) {
  //             loadNextPage();
  //           } else {
  //             // If no articles visible, try loading next page immediately
  //             loadNextPage();
  //           }
  //         }
  //       });
  //     },
  //     {
  //       rootMargin: '100px',
  //     },
  //   );

  //   // Create sentinel element
  //   const sentinel = document.createElement('div');
  //   sentinel.id = 'scroll-sentinel';
  //   sentinel.style.height = '1px';
  //   sentinel.style.background = 'transparent';

  //   if (endOfResults) {
  //     articlesContainer.parentNode.insertBefore(sentinel, endOfResults);
  //   }

  //   // Initialize
  //   filterVisibleArticles();

  //   // Start observing if there are more pages to load
  //   if (currentPage < totalPages && sentinel) {
  //     window.blogObserver.observe(sentinel);
  //   } else if (currentPage >= totalPages) {
  //     if (endOfResults) endOfResults.style.display = 'block';
  //   }

  //   // Handle browser back/forward buttons
  //   window.addEventListener('popstate', function (event) {
  //     // On popstate, just reload the page to get the correct content
  //     window.location.reload();
  //   });
  // });

  document.addEventListener('DOMContentLoaded', function () {
    const countdownElements = document.querySelectorAll('.countdown-timer');
    if (countdownElements.length === 0) return;

    countdownElements.forEach((countdownElement, index) => {
      const resetAfterHours = parseInt(countdownElement.dataset.resetAfter);
      const countdownDurationHours = resetAfterHours;
      const timerId = `countdown-${index}`; // Unique identifier for each timer

      function getNextResetTime() {
        const now = new Date();
        const resetInterval = resetAfterHours * 60 * 60 * 1000;

        let storedResetTime = localStorage.getItem(`${timerId}-reset-time`);

        if (!storedResetTime || new Date(parseInt(storedResetTime)) <= now) {
          const nextReset = new Date(now.getTime() + resetInterval);
          localStorage.setItem(`${timerId}-reset-time`, nextReset.getTime().toString());
          return nextReset;
        }

        return new Date(parseInt(storedResetTime));
      }

      function getCountdownEndTime() {
        const nextReset = getNextResetTime();
        const countdownDuration = countdownDurationHours * 60 * 60 * 1000;

        const now = new Date();
        let storedEndTime = localStorage.getItem(`${timerId}-end-time`);

        if (!storedEndTime || new Date(parseInt(storedEndTime)) <= now) {
          const endTime = new Date(now.getTime() + countdownDuration);
          localStorage.setItem(`${timerId}-end-time`, endTime.getTime().toString());
          return endTime;
        }

        return new Date(parseInt(storedEndTime));
      }

      function updateCountdown() {
        const endTime = getCountdownEndTime();
        const now = new Date();
        const timeDiff = endTime - now;

        if (timeDiff <= 0) {
          localStorage.removeItem(`${timerId}-end-time`);
          localStorage.removeItem(`${timerId}-reset-time`);
          setTimeout(updateCountdown, 1000);
          return;
        }

        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        // Find elements within this specific countdown timer
        const hoursElement = countdownElement.querySelector('.countdown-hours');
        const minutesElement = countdownElement.querySelector('.countdown-minutes');
        const secondsElement = countdownElement.querySelector('.countdown-seconds');

        if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
        if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
        if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
      }

      // Update countdown every second for this specific timer
      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
// End of custom code
